import { appSelectors } from '@appStore/reducers/app'

// Style
import './style.scss'

import clsx from 'clsx'
import { useAppSelector } from 'shared/hooks'
import { typo } from 'shared/styles'

import { DropDownMenu } from './dropDownMenu'
import css from './UserHeaderWidget.module.scss'

export function UserProfilePersona() {
	const email = useAppSelector(
		state => appSelectors.persona(state)?.email ?? ''
	)
	const fullName = useAppSelector(appSelectors.fullName)

	if (!email) {
		return null
	}

	return (
		<>
			<button
				className={clsx(css.trigger, typo.buttonSm)}
				// @ts-ignore
				popovertarget={'header-user-menu'}
				popovertargetaction='toggle'
				type='button'
			>
				<span className={css.name}>{fullName}</span>
				<span>{email}</span>
			</button>

			<DropDownMenu />
		</>
	)
}
